module.exports = __webpack_public_path__ + "html/section-different-devices_40de2009312bd4ea95c5310067f5233f.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-different-devices.html
// module id = w7UM
// module chunks = 64